module.exports = __webpack_public_path__ + "static/img/til142.0d04c65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til142.png
// module id = pNHg
// module chunks = 1